import type { Distance, Pixel } from "@pdfking/math"
import { Mult } from "@pdfking/math"

export const ToPixels = ({ unit_to_px }: { unit_to_px: Pixel }, value: Distance): Pixel =>
  Mult(value as number as Pixel, unit_to_px)
